import { render, staticRenderFns } from "./otherIntegration.vue?vue&type=template&id=35b82d04"
import script from "./otherIntegration.vue?vue&type=script&lang=js"
export * from "./otherIntegration.vue?vue&type=script&lang=js"
import style0 from "./otherIntegration.vue?vue&type=style&index=0&id=35b82d04&prod&lang=css"
import style1 from "./otherIntegration.vue?vue&type=style&index=1&id=35b82d04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports